import React, { FunctionComponent, useContext } from 'react'
import cx from 'classnames'
import {observer} from 'mobx-react'
import { Cells } from './Cells'
import { RowHeader } from './RowHeader'
import SchemerModel from '../../core/SchemerModel'
import {TableStoreContext, TableStore} from './TableStore'

export interface RowProps {
  rowId: string
}

const NoopCmp = () => null

export const Row: FunctionComponent<RowProps> = observer((props) => {
  const {
    rowId
  } = props
  const tableStore: TableStore = useContext(TableStoreContext)

  if (
    !tableStore 
    || !tableStore.data
    || !tableStore.tableMetrics
  ) {
    return null
  }

  const row = tableStore.data.get(rowId)

  const {
    rowMetrics,
    numRows,
    totalStickyHeight,
    rowHeaderWidth
  } = tableStore.tableMetrics
  const [
    , 
    rowIndex,
    rowHeight,
    rowOffsetTop,
    isStickyRow,
    stickyRowOffsetTop
  ] = rowMetrics[rowId]

  // Only observe `visibleCells` if this is a sticky row,
  // non-sticky rows do not need the performance overhead 
  // of responding to `visibleCells`, which updates along
  // with `scrollTop` and `scrollLeft`
  let isStickiedTop = false
  let isStickiedBottom = false
  if (isStickyRow && tableStore.visibleCells) {
    const {
      stuckTopRows,
      stuckBottomRows
    } = tableStore.visibleCells
    isStickiedTop = stuckTopRows.includes(rowId)
    isStickiedBottom = stuckBottomRows.includes(rowId)
  }    
  const isStuck =  isStickiedTop || isStickiedBottom
  const ItemActionsCmp: FunctionComponent<{row: SchemerModel}> = row && !!row.itemActions ? row.itemActions : NoopCmp

  return (
    <div 
      className={cx(
        `sch_row`, 
        row && row.classNames,
        {
          is_sticky: isStickyRow,
          is_stuck: isStuck,
          is_stuck_top: isStickiedTop,
          is_stuck_bottom: isStickiedBottom
        },
        rowIndex % 2 ? 'odd_row' : 'even_row'
      )}
      style={{
        zIndex: isStickiedTop ? rowIndex + 1 : isStickiedBottom ? numRows - (rowIndex + 1) : 0,
        height: rowHeight,
        top: isStickiedTop ? stickyRowOffsetTop : isStickiedBottom ? (tableStore.dims.height - totalStickyHeight + stickyRowOffsetTop) : rowOffsetTop,
      }}
    >
      {row && tableStore.enableRowHeader && tableStore.visibleCells &&
        <RowHeader 
          onStickyClick={() => { tableStore.toggleStickyRow(rowId) }}
          isStuck={tableStore.visibleCells.stuckLeftCols.includes('_header_col')}
          isSticky={isStickyRow}
          width={rowHeaderWidth}
        >
          <ItemActionsCmp row={row} />
        </RowHeader>
      }
      <Cells 
        rowId={rowId}
        row={row}
      />
    </div>
  )
})
